import PasswordSuccessPage from "./password-success-page";

export default PasswordSuccessPage;
